import { ReactElement, useEffect, useState } from 'react';
import './BarHighChart.scss';
import ChartLoader from '../ChartLoader';
import HighChart from '../HighChart';
import { useBarChartOptions } from './hooks';
import type { BarHighChartProps } from './types';

const BarHighChart = (props: BarHighChartProps): ReactElement => {
  const { loading } = props;

  // Below renders the chart after component loads
  // to allow flexbox _layout to load,
  // and the chart to fill container width and height
  const [isLayoutLoaded, setLayoutLoaded] = useState(false);
  useEffect(() => {
    setLayoutLoaded(true);
  }, []);

  const chartOptions = useBarChartOptions(props);

  return (
    <div className='bar-chart-container'>
      {isLayoutLoaded ? (
        <HighChart
          options={chartOptions}
          containerProps={{ style: { height: '100%', width: '100%' } }}
        />
      ) : null}
      {loading && <ChartLoader />}
    </div>
  );
};

export default BarHighChart;
